import {
    Checkbox,
    TableCell,
    TableRow,
} from '@mui/material';
import { INFCe, ModeloNotaFiscal, ModeloNotaFiscalDescricao } from '../../interfaces/INFCe';
import { OpenInNew } from '@mui/icons-material';
import { useDataHora } from '../../../core/hooks/useDataHora';

interface NFCeTableRowProps {
    nfce: INFCe;
    selecionado: boolean;
    toggleSelecionado: (uuid: string) => void;
}

export const NFCeTableRow = ({ nfce, selecionado, toggleSelecionado }: NFCeTableRowProps) => {
    const { dataHoraBr } = useDataHora();
    return (
        <TableRow>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={selecionado}
                    onChange={() => toggleSelecionado(nfce.uuid)}
                />
            </TableCell>
            <TableCell align="center">
                {ModeloNotaFiscalDescricao[nfce.modelo ?? ModeloNotaFiscal.NFCE]}
            </TableCell>
            <TableCell align="center">{nfce.numero}</TableCell>
            <TableCell align="center">{nfce.serie}</TableCell>
            <TableCell align="center">{nfce.destinatarioNome ?? "-"}</TableCell>
            <TableCell align="center">{dataHoraBr(nfce.dataHora)}</TableCell>
            <TableCell align="center">{nfce.protocolo}</TableCell>
            <TableCell align="center">{nfce.status}</TableCell>
            <TableCell align="center">{nfce.mensagemSefaz}</TableCell>
            <TableCell align="center">{nfce.cnpjEmitente}</TableCell>
            <TableCell align="center">
                <OpenInNew
                    sx={{ cursor: 'pointer', color: 'primary.main' }}
                    onClick={() => window.open(`/pedidos/${nfce.ref}`, '_blank')}
                />
            </TableCell>

        </TableRow>
    );
};
